import React from 'react';

import {translate} from 'iss/strings';
import {PlainRestResultMessage} from 'iss/widgets/MessageBox';
import {QuestionList} from 'iss/widgets/QuestionList';

export function BatchOpFailure({message, extraColumns = [], operationResult}) {
  const questions = operationResult.failed.map(({question, ...rest}) => ({...rest, ...question}));

  return <React.Fragment>
    <p>{translate(message, {count: operationResult.failed.length})}</p>
    <QuestionList compact={true} questions={questions} extraColumns={[
      ...extraColumns,
      {
        header: translate('questionOperations.error'),
        accessor: ({result}) => <React.Fragment>
          <div style={{color: "red"}}><PlainRestResultMessage result={result} /></div>
        </React.Fragment>
      }
    ]} />
</React.Fragment>;
}

export function listFailuresWithMessage(message) {
  return (props) => <BatchOpFailure message={message} {...props} />;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/question/BatchOpFailure.jsx